import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// console.log(urlObj)
export const login = ({ username, password, deviceId, autotest }) => {
  const data = {
    username,
    password,
    deviceId,
    autotest,
    grant_type: 'password',
    client_id: 'WSS',
    client_secret: 'Jp123488!!'
  }
  // const params = {
  //   autotest: 1
  // }
  return axios.request({
    url: urlObj.crm + 'uims-oauth/oauth/token',
    // url: 'http://192.168.0.110:5000/uims-oauth/oauth/token',
    data,
    // params,
    method: 'post'
  })
}
// 获取用户信息
// 通过token
export const getUserInfo = token => {
  return axios.request({
    // url: urlObj.crm + 'uims-oauth/authority/account/info',
    url: urlObj.crm + 'uims-oauth/authority/information',
    // url: 'http://192.168.0.102:5000/uims-oauth/authority/information',
    method: 'get'
    // params: {
    //   // client: 'oms',
    //   token
    // }
  })
}
//账户管理-获取个人资料
export function getPersonalData() {
  return axios.request({
    url: `${urlObj.crm}uims-oauth/authority/account/basic/info`,
    method: 'get'
  })
}
// 退出
export const logout = token => {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/oauth/logout',
    method: 'get'
  })
}

// export function getCodeSMS(params) {
//   return axios.request({
//     // url: urlObj.crm +'uims-oauth/authority/code/sms',
//     url: 'http://192.168.0.104:5000/uims-oauth/authority/code/sms',
//     method: 'get',
//     params
//   })
// }
// 忘记密码
export function passwd(data) {
  return axios.request({
    // url: urlObj.crm +'uims-oauth/authority/account/reset/passwd',
    url: urlObj.crm + 'uims-oauth/authority/gateway/account/reset/passwd',
    method: 'post',
    data
  })
}

// 上传图片返回链接
export function uploadFile(data) {
  return axios.request({
    url: urlObj.crm + 'crm/file/uploadFile',
    method: 'post',
    data
  })
}
// 字典查询申请人
export function getStatusList(params) {
  return axios.request({
    url: urlObj.crm + 'crm/dictionariesItem/getDictionariesItemList',
    method: 'get',
    params
  })
}
// 获取省市区联动选择
export function getResAreaByParent(params) {
  return axios.request({
    url: urlObj.crm + 'crm/resarea/getResAreaByParent',
    method: 'get',
    params
  })
}
// 验证码
export function getCodeSMS(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/authority/code/sms',
    method: 'get',
    params
  })
}
// 手机号验证
export function getPhone(data) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/authority/gateway/tenant/register',
    method: 'post',
    data
  })
}
// 验证企业名称
export function getnameable(params) {
  return axios.request({
    url: urlObj.crm + 'crm/register/gateway/nameable',
    method: 'get',
    params
  })
}
// 注册
export function getTenant(data) {
  return axios.request({
    url: urlObj.crm + 'crm/register/gateway/tenant',
    method: 'post',
    data
  })
}
// 更换头像
export function changeAvatar(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/authority/account/avatar',
    // url: 'http://192.168.0.103:5000/uims-oauth/authority/account/avatar',
    method: 'put',
    params
  })
}
// 审核不通过渲染注册信息
export function registerMessage(params) {
  return axios.request({
    url: urlObj.crm + 'crm/tenantRegisterJL/gateway/registerMessage',
    method: 'get',
    params
  })
}

export function updateRegister(data) {
  return axios.request({
    url: urlObj.crm + 'crm/tenantRegisterJL/gateway/updateRegister',
    method: 'put',
    data
  })
}

// 获取极准token
export const ztkalogin = params => {
  return axios.request({
    url: urlObj.ztka + '/etc/login',
    // url: api.tokenApi + '/enter?username='+username+'&password='+password+'&type='+type,
    method: 'post',
    params
  })
}
